import { render } from "./AgentAgencyDetailsAddNewCarrier.vue?vue&type=template&id=7c64e322&scoped=true&lang=pug"
import script from "./AgentAgencyDetailsAddNewCarrier.vue?vue&type=script&lang=js"
export * from "./AgentAgencyDetailsAddNewCarrier.vue?vue&type=script&lang=js"

import "./AgentAgencyDetailsAddNewCarrier.vue?vue&type=style&index=0&id=7c64e322&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c64e322"]])

export default __exports__